<template>
  <component
    :is="component"
    class="button"
    :type="component == 'button' ? 'button' : null"
    :to="to"
    :href="href"
    v-bind="dynamicProps"
    @click="triggerAction(action)"
  >
    <span
      v-if="action.icon"
      class="icon"
    >
      <i
        class="mdi"
        :class="'mdi-' + action.icon"
      />
    </span>
    <span>{{ action.label }}</span>
  </component>
</template>

<script>
export default {
  props: {
    action: {
      required: true,
      type: Object
    }
  },
  computed: {
    component () {
      if (this.action.path) {
        if  (this.action.path.includes("http")) {
          return "a";
        }
        return "router-link";
      }
      return "button";
    },
    to () {
      if (this.component == "router-link") {
        return this.action.path;
      }
      return undefined;
    },
    href () {
      if (this.component == "a") {
        return this.action.path;
      }
      return undefined;
    },
    dynamicProps()
    {
      if (this.action.download) {
        return {
          download: true,
        };
      }
      return {};
    }
  },
  methods: {
    triggerAction (action) {
      if (action.action) {
        action.action();
      }
    }
  }
};
</script>
